module.exports = __webpack_public_path__ + "img/services-background-02.cb089ad6.jpg";